<style lang="scss" src='./TaskDetailsComments.scss' scoped></style>
<template src="./TaskDetailsComments.html"></template>

<script>
import UserAvatar from '@/components/user/avatar/UserAvatar.vue';

export default {
  components: {
    UserAvatar,
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    };
  },
};
</script>

<style>

</style>
